var exports = {
  "k": "xcc377c0b--e28a84--container",
  "O": "xcc377c0b--e28a84--offers",
};

module.exports = exports;
